const page = `

{settings}
document.title: USA-valet: Läget just nu
og.title: USA-valet: Läget just nu
og.image: http://quickshot.imgix.net/USAVAL/polls.png?w=1000
og.description: Senaste siffrorna – så går det för Clinton och Trump
og.url: http://pejl.svt.se/usa-valnatten
siteCatalyst.name: USA-valet: Läget just nu
siteCatalyst.category: lyxartikel
{}

[+page]
{.bild}
fil: USAVAL/valbalk-cuttad.png
storlek: balk
{}
rubrik2: Clinton eller Trump? Så är läget just nu
rubrikmager: I natt väljer USA president – följ utvecklingen här

usagrafik: latestlinjal

usagrafik: latestkarta

usagrafik: kongress

noscript: map


{.sharebuttons}
title: Senaste siffrorna – så går det för Clinton och Trump
url: http://pejl.svt.se/usa-valnatten
{}


[]
`;

export default page;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/data/articles/usa-valnatt-grafik.js
 **/